import { makeAutoObservable } from 'mobx';
import ICompany from '@interfaces/ICompany';

class CompanyStore {
  company: ICompany | null = null;

  loading = false;

  error = false;

  constructor() {
    makeAutoObservable(this);
  }

  setCompany(company: ICompany) {
    this.company = company;
    this.loading = false;
    this.error = false;
  }

  setLoading(loading: boolean) {
    this.loading = loading;
  }

  setError(error: boolean) {
    this.error = error;
    this.loading = false;
  }

  reset() {
    this.company = null;
    this.loading = false;
    this.error = false;
  }

  async load(api: any) {
    try {
      this.setLoading(true);
      const response = await api.get('/company');
      this.setCompany(response.data);
    } catch (error) {
      this.setError(true);
    }
  }
}

export default new CompanyStore();
